<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-11-23 20:11:17
 * @FilePath: \web\src\components\Administrator\AdminHome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-container class="home-container">
    <el-header>
      <div>
        <a href="/">
          <img src="../../assets/images/logo.png" alt="" />
        </a>
        <span>基金会信息后台管理系统</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <el-container>
      <el-main>
        <!-- <router-view></router-view> -->
        <layout></layout>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Layout from '@/layout/index'

export default {
  data() {
    return {}
  },
  components: {
    Layout
  },
  created() {},
  methods: {
    logout() {
      //清空token
      window.sessionStorage.clear()
      //跳转到登录页
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.el-header {
  background-color: rgb(55, 61, 63);
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 60px;
    img {
      width: 60px;
      height: 100%;
      border-radius: 50%;
    }
    span {
      margin-left: 15px;
    }
  }
}
// .el-main {
//   // background-color: rgb(233, 237, 240);
// }

.iconfont {
  margin-right: 10px;
}
</style>
